import React, { Component } from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';
import withRequired from './withRequired';

class InputCheckbox extends Component {
  render() {
    let errorMgs;

    if (this.props.errors) {
      this.props.errors.details.forEach((error) => {
        if (error.fieldName === this.props.name) {
          errorMgs = error.messages;
        }
      });
    }

    return (
      <FormGroup check>
        <Label check className={errorMgs ? 'form-control is-invalid' : ''}>
          <Input
            type="checkbox"
            name={this.props.name}
            value={this.props.value}
            checked={this.props.checked}
            onChange={this.props.handleChange}
            required={this.props.required}
            className={this.props.large ? 'lg' : ''}
          />

          {'  '}
          <div className="checkmark checkbox" />
          {this.props.required ? <sup>*</sup> : ''}
          {'  '}
          {this.props.label}
        </Label>

        <FormFeedback>
          {errorMgs ? errorMgs.map((message, k) => <li key={k}>{message}</li>) : ''}
        </FormFeedback>
      </FormGroup>
    );
  }
}

InputCheckbox.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
  validationErrors: PropTypes.object, //eslint-disable-line
  large: PropTypes.bool,
};

InputCheckbox.defaultProps = {
  checked: false,
  label: undefined,
  required: false,
  large: false,
};

export default withRequired(InputCheckbox);
